import React from 'react'
import { Typography, Grid } from "@material-ui/core";
import TempoConfigRow from "./TempoConfigRow";

export default function ProjectsTable({ projects, accountId, screensEnabled }) {
  return (
    <>
      <Grid container>
        <Grid item xs={3}>
          <Typography align="center" variant="subtitle1">
            Project
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography align="center" variant="subtitle1">
            Tempo Configuration
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography align="center" variant="subtitle1">
            Webhook/Screens Enabled
          </Typography>
        </Grid>
        <Grid item xs={3}></Grid>
      </Grid>
      <hr />
      {projects.map((project) => (
        <TempoConfigRow
          key={project._id}
          accountId={accountId}
          projectId={project._id}
          name={project.name}
          tempoData={project.tempo || {}}
          screensEnabled={screensEnabled}
          hasTempoWebhook={project.webhooks ? project.webhooks.find(webhook => webhook.type === "tempo") : false}
        />
      ))}
    </>
  );
}
